// // src/services/pwaService.ts
// import { toast } from 'react-toastify';

// interface BeforeInstallPromptEvent extends Event {
//   prompt: () => Promise<void>;
//   userChoice: Promise<{ outcome: "accepted" | "dismissed" }>;
// }

// interface PWAState {
//   registration: ServiceWorkerRegistration | null;
//   updateToast: any;
//   deferredPrompt: BeforeInstallPromptEvent | null;
//   isInstallable: boolean;
//   isInstalled: boolean;
//   showInstallModal: boolean;
// }

// class PWAService {
//   private state: PWAState = {
//     registration: null,
//     updateToast: null,
//     deferredPrompt: null,
//     isInstallable: false,
//     isInstalled: false,
//     showInstallModal: false
//   };

//   private showUpdateToast() {
//     if (this.state.updateToast) return;

//     this.state.updateToast = toast.info(
//       'Nueva versión disponible. Click aquí para actualizar.',
//       {
//         autoClose: false,
//         closeOnClick: false,
//         pauseOnFocusLoss: false,
//         draggable: true,
//         closeButton: true,
//         onClick: () => {
//           if (this.state.registration?.waiting) {
//             this.state.registration.waiting.postMessage({ type: 'SKIP_WAITING' });
//           }
//           if (this.state.updateToast) {
//             toast.dismiss(this.state.updateToast);
//             this.state.updateToast = null;
//           }
//           window.location.reload();
//         }
//       }
//     );
//   }

//   private async checkForUpdates() {
//     try {
//       if (document.visibilityState === 'visible') {
//         await this.state.registration?.update();
//       }
//     } catch (error) {
//       console.error('Error al verificar actualizaciones:', error);
//     }
//   }

//   async register() {
//     if (!('serviceWorker' in navigator)) return;

//     try {
//       if (this.state.registration) return this.state.registration;

//       // Check if already installed
//       this.state.isInstalled = window.matchMedia('(display-mode: standalone)').matches;

//       // Installation events
//       window.addEventListener('beforeinstallprompt', (e) => {
//         e.preventDefault();
//         this.state.deferredPrompt = e as BeforeInstallPromptEvent;
//         this.state.isInstallable = true;
//          // Show modal only if user hasn't interacted before
//         const hasInteracted = localStorage.getItem('pwaInstallInteracted');
//         if (hasInteracted != 'true') {
//             this.state.showInstallModal = true;
//         }
//       });

//       window.addEventListener('appinstalled', () => {
//         this.state.deferredPrompt = null;
//         this.state.isInstalled = true;
//         this.state.isInstallable = false;
//         this.state.showInstallModal = false;
//         toast.success('¡Aplicación instalada correctamente!');
//       });

//       // Register Service Worker
//       this.state.registration = await navigator.serviceWorker.register('/sw.js', {
//         scope: '/'
//       });

//       // Update detection
//       this.state.registration.addEventListener('updatefound', () => {
//         const newWorker = this.state.registration?.installing;
//         if (!newWorker) return;

//         newWorker.addEventListener('statechange', () => {
//           if (
//             newWorker.state === 'installed' &&
//             navigator.serviceWorker.controller
//           ) {
//             this.showUpdateToast();
//           }
//         });
//       });

//       // Update checking intervals
//       setInterval(() => this.checkForUpdates(), 30 * 1000);
//       document.addEventListener('visibilitychange', () => {
//         if (document.visibilityState === 'visible') {
//           this.checkForUpdates();
//         }
//       });
//       window.addEventListener('online', () => this.checkForUpdates());

//       return this.state.registration;
//     } catch (error) {
//       console.error('Error al registrar el Service Worker:', error);
//     }
//   }

//   async promptInstall() {

//     if (!this.state.deferredPrompt) {
//       toast.error('La instalación no está disponible en este momento');
//       return;
//     }

//     try {
//       await this.state.deferredPrompt.prompt();
//       const choice = await this.state.deferredPrompt.userChoice;

//       if (choice.outcome === 'accepted') {
//         toast.success('¡Gracias por instalar nuestra app!');
//       }
//        localStorage.setItem('pwaInstallInteracted', 'true');
//       this.state.deferredPrompt = null;
//       this.state.showInstallModal = false;
//     } catch (error) {
//       console.error('Error al intentar instalar:', error);
//       toast.error('Error al intentar instalar la aplicación');
//     }
//   }

//   dismissInstall() {
//     localStorage.setItem('pwaInstallInteracted', 'true');
//     this.state.showInstallModal = false;
//   }

//   getState(): PWAState {
//     return { ...this.state };
//   }
// }

// export const pwaService = new PWAService();

// src/services/pwaService.ts
import { toast } from 'react-toastify';

interface BeforeInstallPromptEvent extends Event {
  prompt: () => Promise<void>;
  userChoice: Promise<{ outcome: "accepted" | "dismissed" }>;
}

interface PWAState {
  registration: ServiceWorkerRegistration | null;
  updateToast: any;
  deferredPrompt: BeforeInstallPromptEvent | null;
  isInstallable: boolean;
  isInstalled: boolean;
  showInstallModal: boolean;
}

class PWAService {
  private state: PWAState = {
    registration: null,
    updateToast: null,
    deferredPrompt: null,
    isInstallable: false,
    isInstalled: false,
    showInstallModal: false
  };

  private handleAppInstalled = () => {
    this.state.deferredPrompt = null;
    this.state.isInstalled = true;
    this.state.isInstallable = false;
    this.state.showInstallModal = false;
    toast.success('¡Aplicación instalada correctamente!');
  };

  private handleBeforeInstallPrompt = (e: Event) => {
    e.preventDefault();
    this.state.deferredPrompt = e as BeforeInstallPromptEvent;
    this.state.isInstallable = true;
    // Show modal only if user hasn't interacted before
    const hasInteracted = localStorage.getItem('pwaInstallInteracted');
    if (hasInteracted !== 'true') {
      this.state.showInstallModal = true;
    }
  };

  private showUpdateToast() {
    if (this.state.updateToast) return;

    this.state.updateToast = toast.info(
      'Nueva versión disponible. Click aquí para actualizar.',
      {
        autoClose: false,
        closeOnClick: false,
        pauseOnFocusLoss: false,
        draggable: true,
        closeButton: true,
        onClick: () => {
          if (this.state.registration?.waiting) {
            this.state.registration.waiting.postMessage({ type: 'SKIP_WAITING' });
          }
          if (this.state.updateToast) {
            toast.dismiss(this.state.updateToast);
            this.state.updateToast = null;
          }
          window.location.reload();
        }
      }
    );
  }

  private async checkForUpdates() {
    try {
      if (document.visibilityState === 'visible') {
        await this.state.registration?.update();
      }
    } catch (error) {
      console.error('Error al verificar actualizaciones:', error);
    }
  }

  private cleanup() {
    // Eliminar event listeners existentes
    window.removeEventListener('appinstalled', this.handleAppInstalled);
    window.removeEventListener('beforeinstallprompt', this.handleBeforeInstallPrompt);
  }

  async register() {
    if (!('serviceWorker' in navigator)) return;

    try {
      if (this.state.registration) return this.state.registration;

      // Limpiar event listeners anteriores
      this.cleanup();

      // Check if already installed
      this.state.isInstalled = window.matchMedia('(display-mode: standalone)').matches;

      // Installation events
      window.addEventListener('beforeinstallprompt', this.handleBeforeInstallPrompt);
      window.addEventListener('appinstalled', this.handleAppInstalled);

      // Register Service Worker
      this.state.registration = await navigator.serviceWorker.register('/sw.js', {
        scope: '/'
      });

      // Update detection
      this.state.registration.addEventListener('updatefound', () => {
        const newWorker = this.state.registration?.installing;
        if (!newWorker) return;

        newWorker.addEventListener('statechange', () => {
          if (
            newWorker.state === 'installed' &&
            navigator.serviceWorker.controller
          ) {
            this.showUpdateToast();
          }
        });
      });

      // Update checking intervals
      const updateInterval = setInterval(() => this.checkForUpdates(), 30 * 1000);
      
      const visibilityHandler = () => {
        if (document.visibilityState === 'visible') {
          this.checkForUpdates();
        }
      };
      
      const onlineHandler = () => this.checkForUpdates();
      
      document.addEventListener('visibilitychange', visibilityHandler);
      window.addEventListener('online', onlineHandler);

      // Cleanup function for intervals and event listeners
      const cleanup = () => {
        clearInterval(updateInterval);
        document.removeEventListener('visibilitychange', visibilityHandler);
        window.removeEventListener('online', onlineHandler);
        this.cleanup();
      };

      // Cleanup on window unload
      window.addEventListener('unload', cleanup);

      return this.state.registration;
    } catch (error) {
      console.error('Error al registrar el Service Worker:', error);
    }
  }

  async promptInstall() {
    if (!this.state.deferredPrompt) {
      toast.error('La instalación no está disponible en este momento');
      return;
    }

    try {
      await this.state.deferredPrompt.prompt();
      const choice = await this.state.deferredPrompt.userChoice;

      if (choice.outcome === 'accepted') {
        toast.success('¡Gracias por instalar nuestra app!');
      }
      localStorage.setItem('pwaInstallInteracted', 'true');
      this.state.deferredPrompt = null;
      this.state.showInstallModal = false;
    } catch (error) {
      console.error('Error al intentar instalar:', error);
      toast.error('Error al intentar instalar la aplicación');
    }
  }
 
  dismissInstall() {
    localStorage.setItem('pwaInstallInteracted', 'true');
    this.state.showInstallModal = false;
  }

  getState(): PWAState {
    return { ...this.state };
  }
}

export const pwaService = new PWAService();